import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ar from './locales/ar';
import en from './locales/en';
import fr from './locales/fr';
import tr from './locales/tr';
import es from './locales/es';
import de from './locales/de';
import zh from './locales/zh';
import ru from './locales/ru';
import pt from './locales/pt';
import ja from './locales/ja';
import ko from './locales/ko';
import hi from './locales/hi';

export const languages = [
  { code: 'ar', name: 'العربية', dir: 'rtl', flag: '🇸🇦' },
  { code: 'en', name: 'English', dir: 'ltr', flag: '🇺🇸' },
  { code: 'fr', name: 'Français', dir: 'ltr', flag: '🇫🇷' },
  { code: 'tr', name: 'Türkçe', dir: 'ltr', flag: '🇹🇷' },
  { code: 'es', name: 'Español', dir: 'ltr', flag: '🇪🇸' },
  { code: 'de', name: 'Deutsch', dir: 'ltr', flag: '🇩🇪' },
  { code: 'zh', name: '中文', dir: 'ltr', flag: '🇨🇳' },
  { code: 'ru', name: 'Русский', dir: 'ltr', flag: '🇷🇺' },
  { code: 'pt', name: 'Português', dir: 'ltr', flag: '🇧🇷' },
  { code: 'ja', name: '日本語', dir: 'ltr', flag: '🇯🇵' },
  { code: 'ko', name: '한국어', dir: 'ltr', flag: '🇰🇷' },
  { code: 'hi', name: 'हिन्दी', dir: 'ltr', flag: '🇮🇳' },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { ar, en, fr, tr, es, de, zh, ru, pt, ja, ko, hi },
    fallbackLng: 'ar',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
